import NewCreditCards from './NewCreditCards';

const CreditCardForm = ({ form }) => {
  return (
    <div className="credit-card-form-container">
      <NewCreditCards form={form} />
      {/*<AutomaticPaymentInstruction form={form} />*/}
    </div>
  );
};

export default CreditCardForm;
